import { initContract } from '@ts-rest/core'
import { ErrorResponseSchema } from '../../shared'
import { DiscountCategoryGetRequest, DiscountCategoryGetResponse, DiscountCategoryPatchRequest, DiscountCategoryPostRequest, DiscountCategorySchema, DiscountGetBatchRequestSchema, DiscountGetBatchResponseSchema, DiscountGetRequest, DiscountGetResponse, DiscountPatchRequest, DiscountPostRequest, DiscountSchema, GenericCrudDeleteRequest, GenericCrudDeleteResponse, GenericCrudPathParams, GenericCrudPostResponse } from './schemas'

const c = initContract()

const discountOptions = {
  pathPrefix: '/discounts',
  commonResponses: {
    400: ErrorResponseSchema,
    404: ErrorResponseSchema,
    409: ErrorResponseSchema,
    500: ErrorResponseSchema,
  },
}

export const discountCategoryContract = c.router({
  getCategories: {
    method: 'GET',
    path: '/categories',
    summary: 'Retrieve all discount categories',
    query: DiscountCategoryGetRequest,
    responses: {
      200: DiscountCategoryGetResponse,
    },
  },

  createCategory: {
    method: 'POST',
    path: '/categories',
    summary: 'Create a new discount category',
    description: 'Will throw an error if name already exists',
    body: DiscountCategoryPostRequest,
    responses: {
      201: DiscountCategorySchema,
    },
  },

  updateCategory: {
    method: 'PATCH',
    path: '/categories/:uuid',
    pathParams: GenericCrudPathParams,
    summary: 'Update an existing discount category',
    description: 'Will throw an error if name already exists',
    body: DiscountCategoryPatchRequest,
    responses: {
      200: DiscountCategorySchema,
    },
  },

  deleteCategory: {
    method: 'DELETE',
    path: '/categories/:uuid',
    pathParams: GenericCrudPathParams,
    summary: 'Soft-delete a discount category',
    body: null,
    responses: {
      200: GenericCrudDeleteResponse,
    },
  },
}, discountOptions)

export const discountContract = c.router({
  getDiscounts: {
    method: 'GET',
    path: '/discounts',
    summary: 'Retrieve all discounts',
    query: DiscountGetRequest,
    responses: {
      200: DiscountGetResponse,
    },
  },

  getDiscountsByIds: {
    method: 'POST',
    path: '/discounts/by-ids',
    body: DiscountGetBatchRequestSchema,
    responses: {
      200: DiscountGetBatchResponseSchema,
    },
  },

  getSpecificDiscount: {
    method: 'GET',
    path: '/discounts/:uuid',
    pathParams: GenericCrudPathParams,
    summary: 'Retrieve specific discount',
    responses: {
      200: DiscountSchema,
    },
  },

  createDiscount: {
    method: 'POST',
    path: '/discounts',
    summary: 'Create a new discount',
    body: DiscountPostRequest,
    responses: {
      201: GenericCrudPostResponse,
    },
  },

  updateDiscount: {
    method: 'PATCH',
    path: '/discounts/:uuid',
    pathParams: GenericCrudPathParams,
    summary: 'Update a discount',
    body: DiscountPatchRequest,
    responses: {
      200: DiscountSchema,
    },
  },

  deleteDiscount: {
    method: 'DELETE',
    path: '/discounts/:uuid',
    pathParams: GenericCrudPathParams,
    summary: 'Soft-delete a discount',
    body: GenericCrudDeleteRequest,
    responses: {
      200: GenericCrudDeleteResponse,
    },
  },
}, discountOptions)

export const discountsContract = c.router({
  discounts: discountContract,
  categories: discountCategoryContract,
})
